/**
 * Application constants
 */

export const INPUT_LIMITS = {
  MIN: 0,
  MAX: 1000,
};

export const RANDOM_MULTIPLIER_MAX = 5;
export const RANDOM_COEFFICIENT_MAX = 10;
export const RANDOM_OFFSET_MAX = 30;
export const LARGE_NUMBER_THRESHOLD = 70;
export const SMALL_NUMBER_THRESHOLD = 10;
export const MEDIUM_NUMBER_THRESHOLD = 100;

export const SIGNS = ['-', '+'];
